import { HardHat, UtensilsCrossed, HeartPulse, Trees, Truck, Building2 } from 'lucide-react';

export const INDUSTRIES = [
  { name: 'Construction', slug: 'construction', Icon: HardHat, color: '#E97A2B',
    desc: 'Highest-risk industry in CA. CSLB requires proof of coverage.',
    avgCost: '$5-$15 per $100 payroll' },
  { name: 'Restaurants', slug: 'restaurants', Icon: UtensilsCrossed, color: '#E74C3C',
    desc: 'High injury rates from slips, burns, and cuts. All staff must be covered.',
    avgCost: '$2-$5 per $100 payroll' },
  { name: 'Home Health / Caregiving', slug: 'home-health', Icon: HeartPulse, color: '#2ECC71',
    desc: 'Fastest-growing and most-audited sector. AB5 impacts classification.',
    avgCost: '$3-$8 per $100 payroll' },
  { name: 'Landscaping', slug: 'landscaping', Icon: Trees, color: '#27AE60',
    desc: 'Year-round exposure. Seasonal workers need the same coverage.',
    avgCost: '$4-$12 per $100 payroll' },
  { name: 'Trucking / Delivery', slug: 'trucking', Icon: Truck, color: '#3498DB',
    desc: 'AB5 changed owner-operator rules. Premiums based on payroll, not miles.',
    avgCost: '$5-$14 per $100 payroll' },
  { name: 'All Other Businesses', slug: 'all-businesses', Icon: Building2, color: '#8E44AD',
    desc: 'Every CA employer with 1+ employee needs coverage. No exceptions.',
    avgCost: '$1-$15 per $100 payroll' }
];

export const INDUSTRY_MAP = {};
INDUSTRIES.forEach(i => { INDUSTRY_MAP[i.slug] = i; });

export const EMPLOYEE_COUNTS = ['1-5', '6-10', '11-25', '26-50', '51-100', '100+'];
